import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BrandMark from "@/components/BrandMark";

const Col = ({ title, links }) => (
  <div>
    <div className="label-eyebrow mb-3">{title}</div>
    <ul className="space-y-2 text-sm">
      {links.map(([to, label, tid]) => (
        <li key={to}><Link to={to} data-testid={tid} className="text-[color:var(--ayur-ink-2)] hover:text-[color:var(--ayur-emerald)] link-underline">{label}</Link></li>
      ))}
    </ul>
  </div>
);

export default function SiteFooter() {
  const { user } = useAuth();
  const account = user
    ? [["/app", "My feed", "footer-feed-link"], ["/app/profile", "My profile", "footer-profile-link"]]
    : [["/signup", "Join VaidGram", "footer-signup-link"], ["/login", "Log in", "footer-login-link"]];
  return (
    <footer className="border-t border-[color:var(--ayur-border)] bg-[color:var(--ayur-cream-2)] pb-20 md:pb-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2 text-[color:var(--ayur-emerald)]" data-testid="footer-brand">
            <BrandMark size={36} /><span className="font-serif-display text-xl font-semibold">VaidGram</span>
          </Link>
          <p className="mt-3 text-xs text-[color:var(--ayur-mute)] leading-relaxed">India's private network for BAMS, MD & MS Ayurveda scholars.</p>
        </div>
        <Col title="Admissions" links={[["/ayurveda-colleges", "Ayurveda Colleges 2026-27 (BAMS, MD, MS)", "footer-college-directory-link"],
          ["/ayurveda-colleges/maharashtra", "BAMS colleges in Maharashtra", "footer-mh-link"],
          ["/ayurveda-colleges/karnataka", "BAMS colleges in Karnataka", "footer-ka-link"],
          ["/ayurveda-colleges/uttar-pradesh", "BAMS colleges in Uttar Pradesh", "footer-up-link"]]} />
        <Col title="Community" links={[["/jobs", "Ayurveda & BAMS jobs", "footer-jobs-link"], ["/", "About VaidGram", "footer-about-link"]]} />
        <Col title="Account" links={account} />
      </div>
      <div className="max-w-7xl mx-auto px-6 py-4 border-t border-[color:var(--ayur-border)] text-xs text-[color:var(--ayur-mute)] font-mono-brand">
        © VaidGram · A community for BAMS, MD & MS Ayurveda scholars
      </div>
    </footer>
  );
}
